import React from "react";
import { ArrowRight, Phone } from "lucide-react";
import { COMPANY } from "../../data/constants";

const scrollTo = (id) => (e) => {
  e.preventDefault();
  const el = document.getElementById(id);
  if (el) {
    const y = el.getBoundingClientRect().top + window.scrollY - 88;
    window.scrollTo({ top: y, behavior: "smooth" });
  }
};

export default function CTASection() {
  return (
    <section
      data-testid="cta-strip"
      className="relative bg-[#F47B20] border-y border-black/20 overflow-hidden"
    >
      <div className="absolute inset-0 stripe-bg opacity-30 mix-blend-multiply pointer-events-none" />
      <div className="relative mx-auto max-w-[1400px] px-6 md:px-10 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
          <div className="md:col-span-8">
            <p className="text-[10px] font-bold uppercase tracking-[0.35em] text-black/60 mb-3">
              Ready when you are
            </p>
            <h2 className="font-display font-black uppercase tracking-tighter text-black text-3xl sm:text-4xl md:text-5xl leading-[0.95]">
              Ready to transform your business?
            </h2>
            <p className="mt-4 text-black/80 text-base md:text-lg max-w-2xl">
              Book a 30-minute discovery call. We'll map your workflow, flag the
              biggest leak, and tell you honestly whether ERP, integration, web
              or marketing is the right next move.
            </p>
          </div>
          <div className="md:col-span-4 flex flex-col gap-3 md:items-end">
            <a
              href="#contact"
              onClick={scrollTo("contact")}
              data-testid="cta-strip-start-project"
              className="group inline-flex items-center justify-center gap-3 px-7 py-4 bg-black text-white font-bold uppercase tracking-[0.2em] text-xs hover:bg-[#0B0F19] transition-all duration-300 hover:-translate-y-0.5 w-full md:w-auto"
            >
              Start a Project
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </a>
            <a
              href={`tel:${COMPANY.phone}`}
              data-testid="cta-strip-call"
              className="inline-flex items-center justify-center gap-3 px-7 py-4 border border-black/30 text-black font-bold uppercase tracking-[0.2em] text-xs hover:bg-black/10 transition-colors w-full md:w-auto"
            >
              <Phone className="w-4 h-4" />
              {COMPANY.phoneDisplay}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
